import { httpCreate } from './http';

const http = httpCreate('/srv/watermarkHistory');

export const watermarkHistory = {
	get(id) {
		return http.get(`/${id}`);
	},
	delete(id) {
		return http.delete(`/${id}`);
	}
};
